import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import './ProductTemplate.css';
import { makeStyles, Popover, Typography, CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    popover: {
        pointerEvents: 'none',
    },
    paper: {
        padding: theme.spacing(1),
    },
}));

function ProductTemplate({ RetailerUid, Image, ProductName, MRP, PackagingSize, Discount, Compostions, StoreName, StoreAddress }) {
    const history = useHistory();
    const routeToRetailerDetails = async (RetailerUid) => {
        history.push(`/retailer-details/${RetailerUid}`);
    }

    return (
        <>
            <div className="col-lg-4 col-md-4 col-sm-12 mr-1 mb-3 productTemplate__contentDisplay" onClick={() => routeToRetailerDetails(RetailerUid)}>
                <div className="card card__product">
                    <div className="card-body d-flex flex-column productTemplate__content">
                        <div className="">
                            {/* <div className="productTemplate__companyLogoBox d-flex justify-content-center align-items-center">
                                {imageUrl !== '' ? <img src={imageUrl} alt="Store Name" className="img-fluid productTemplate__companyLogo" />
                                    : <img src={Image} alt="Store Name" className="img-fluid productTemplate__companyLogo" />}
                            </div> */}
                            <h5 className="product-title productTemplate__title">{ProductName} {StoreName ? `- ${StoreName}` : ''}</h5>
                            {StoreAddress && <p className="product-title productTemplate__title">{StoreAddress}</p>}
                            <p className="product-title productTemplate__title"><b>Compostions</b> : {Compostions}</p>
                            <p className="product-title productTemplate__title"><b>MRP</b> : Rs. {MRP} {PackagingSize && PackagingSize != "" ? `per ${PackagingSize}` : '' }</p>
                            <p className="product-title productTemplate__title"><b>Discount</b> : {Discount}%</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProductTemplate
